export interface Application {
   _id: string;
   status: TApplicationStatus;
   user_id: string;
   payment_id: string;
   card_photo: string;
   medical_certificate: string;
   gp_id: string | null;
   type: string;
   deletedAt: string | null;
   createdAt: string;
   updatedAt: string;
}

export const ApplicationStatus = {
   REVIEW: 'review',
   REJECTED: 'rejected',
   APPROVED: 'approved',
} as const;

export type TApplicationStatus = (typeof ApplicationStatus)[keyof typeof ApplicationStatus];
